import React from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Assuming keel is imported correctly
import keel from "../../assest/images/Keel.png";

const ReusablePDFLayout = ({ children }) => {
  return (

    <div
      style={{
        width: "210mm", // A4 width
        height: "297mm", // A4 height
        padding: "10mm 0mm", // Padding to maintain spacing inside
        position: "relative",
        // border: "1px solid black",
        backgroundColor: "white",
        // Space between pages when printing
        boxShadow: "0px 0px 5px rgba(0,0,0,0.2)", // Optional shadow
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "0 10mm 0 20mm",
          justifyContent: "space-between",
        }}
      >
        <div>
          <img src={keel} height={"90px"} />
        </div>
        <div className="font-name">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ width: "40%" }}>CIN:</p>
            <p style={{ width: "70%" }}>U72900TN2022PTC155375</p>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ width: "40%" }}>GSTIN:</p>
            <p style={{ width: "70%" }}>33AAJCK7889H1ZX</p>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ width: "40%" }}>MAIL:</p>
            <p style={{ width: "70%" }}>info@keelis.com</p>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p style={{ width: "40%" }}> WEB:</p>
            <p style={{ width: "70%" }}>www.keelis.com</p>
          </div>
        </div>
      </div>
      <div>{children}</div>
      <div className="footer">
        <p className="keel">KEEL INFO SOLUTION PRIVATE LIMITED</p>
        <p className="keelsec">No. 672, 3rd Floor, Temple Tower, Anna Salai, CIT Nagar West, Nandanam</p>
        <p className="keelsec">Chennai, Tamil Nadu – 600035</p>
      </div>
    </div>
  );
};

export default ReusablePDFLayout;
